import { usePhamVi } from '../../../hooks/usePhamVi';
import { oidcEnabled } from '../../../lib/auth/oidc';
import { useAuthStore } from '../../../stores/auth';
import { useNguCanhCuaToi } from './useNguCanhCuaToi';

/**
 * Tenant của người đang đăng nhập ở cổng tenant.
 *
 * - Đăng nhập thật: `tenant_id` của `GET /users/me/context` (ADR-0034) — cùng
 *   query `NguCanhGate` đã tải, nên không gọi thêm lần nào.
 * - Tài khoản mẫu (chưa cấu hình Keycloak): `tenantId` khai sẵn ở tài khoản.
 *   Không gọi `me/context` lúc này: hàm tải ngữ cảnh ghi đè quyền của tài
 *   khoản mẫu. Đăng nhập thật mà mở `?mock=` thì repository trả ngữ cảnh mẫu.
 *
 * `tenant_id` không bao giờ lấy từ URL hay ô nhập (MUSE.md mục 3). Nhân sự nền
 * tảng xem chéo giao diện tenant không có ngữ cảnh tenant: trả `undefined`, màn
 * hiện lời dẫn sang cổng quản trị.
 */
export function useTenantCuaToi(): { tenantId: string | undefined; dangTai: boolean } {
  const phamVi = usePhamVi();
  const that = oidcEnabled();
  const ctx = useNguCanhCuaToi(that && phamVi === 'tenant');
  const tenantMau = useAuthStore((s) => s.user?.tenantId);

  if (phamVi !== 'tenant') return { tenantId: undefined, dangTai: false };
  if (!that) return { tenantId: tenantMau, dangTai: false };
  return { tenantId: ctx.data?.tenant_id, dangTai: ctx.isLoading };
}
